import {
  Component, EventEmitter, input, Output,
} from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-empty-table',
    templateUrl: './empty-table.component.html',
    styleUrls: ['./empty-table.component.scss'],
})
export class EmptyTableComponent {
  icon = input.required<string>();

  emptyText = input.required<string>();

  buttonText = input<string>();

  @Output() btnClick = new EventEmitter<void>();
}
